import React from "react";
import "../HomePage.css";
import {
	Paper,
	Typography,
	CircularProgress,
} from "../../../common/MaterialComponent";
import { ErrorPage } from "../../ErrorPage/ErrorPage";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

interface HomePageDescriptionProps {
	description?: string;
	error?: string;
}

export const HomePageDescription: React.FC<HomePageDescriptionProps> = ({
	description,
	error,
}) => {
	const strings = useGetComponentStringsContext().HomePage;

	return (
		<div>
			{error ? (
				<ErrorPage message={strings.errorMessage} />
			) : description === undefined ? (
				<div className="loader">
					<CircularProgress size={50} />
				</div>
			) : (
				<Paper color="textSecondary" className="paper">
					<Typography component="div">{description}</Typography>
				</Paper>
			)}
		</div>
	);
};
